module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-history-selected@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-betmenu/btn-history-selected@2x.png
// module id = 627
// module chunks = 0